import * as types from './mutation-types'

const matutaions = {
  [types.SET_CURRENT_INDEX](state, index) {
    state.currentIndex = index
  },
  [types.SET_SHOW_TASK](state, index) {
    state.showTask = index
  },
  [types.SET_SHOW_WATERAREA](state, index) {
    state.showWaterArea = index
  },
  [types.SET_SHOW_ECOLOGICALLINE](state, index) {
    state.showEcologicalLine = index
  },
  [types.SET_SHOW_NATURERESERVE](state, index) {
    state.showNatureReserve = index
  },
  [types.SET_SHOW_PUMPSTATION](state, index) {
    state.showPumpStation = index
  },
  [types.SET_SHOW_OUTLET](state, index) {
    state.showOutLet = index
  },
  [types.SET_SHOW_ENTERPRISE](state, index) {
    state.showEnterprise = index
  },
  [types.SET_SHOW_UAV](state, index) {
    state.showUav = index
  },
  [types.SET_SHOW_VEHICLE](state, index) {
    state.showVehicle = index
  },
  [types.SET_SHOW_EQUIPMENT](state, index) {
    state.showEquipment = index
  },
  [types.SET_SHOW_PERSONNEL](state, index) {
    state.showPersonnel = index
  },
  [types.SET_SHOW_LEFT_MENU](state, index) {
    state.showLeftMenu = index
  },
  [types.SET_SHOW_RIGHT_MENU](state, index) {
    state.showRightMenu = index
  },
  [types.SET_SHOW_NAV_BAR](state, index) {
    state.showNavBar = index
  },
  [types.SET_BEGIN_RANG](state, index) {
    state.beginRang = index
  },
  [types.SET_CHANGE_MAP](state, index) {
    state.changeMap = index
  },
  [types.SET_SHOW_STATISTICL](state, index) {
    state.showStatistical = index
  },
  [types.SET_CHANGE_TYPE](state, index) {
    state.changeType = index
  },
  [types.SET_CHANGE_POINT](state, index) {
    state.changePoint = index
  },
  // 从localStorage中初始化会话列表
  [types.SET_SESSIONS](state, {
    sessions
  }) {
    state.sessions = sessions;
  },
  // 发送消息
  [types.SEND_MESSAGE](state, {
    content,
    self
  }) {
    let session = state.sessions.find(item => item.toUid === state.currentSessionId);
    var a = {
      content: content,
      date: new Date(),
      self: self
    }

    let messages = []
    messages.push(a)
    session.messages = messages;
  },

  //  选择会话
  [types.SELECT_SESSION](state, {
    id
  }) {
    state.currentSessionId = id;
  },
  setLogo(state, logo) {
    // setColors
    state.logo = logo;
    localStorage.setItem('logo', logo)
  },

  setColors(state, colors) {
    // setColors
    state.lbcolors = colors;
    localStorage.setItem('lbcolors', colors)
  },

  closeMessage(state, abc) {
    state.isClose = abc;
  },
  setDetail(state, isShowRights) {
    state.isShowRights = isShowRights
  },
  //任务详情信息
  setTaskInfo(state, taskDetails) {
    state.taskDetails = taskDetails
  },
  addEmail(state, keys) {
    state.addMail = keys
  },
  addMsgCount(state, keys) {
    // state.newMsg.count=0
    state.unreadCount = keys
  },
  addheart(state, keys) {
    state.heartss = keys
  },
  //  设置筛选关键词
  [types.SET_FILTER_KEY](state, {
    key
  }) {
    state.filterKey = key;
  },

  [types.SET_USER](state, {
    user
  }) {
    state.user = user;
  },
  [types.SET_MESSAGES](state, {
    messages
  }) {
    state.messages = messages
  },
  [types.SET_MSGMAP](state, {
    msgMap
  }) {
    state.msgMap = msgMap
  },
  [types.SET_INFO_MAP](state, {
    infoMap
  }) {
    state.infoMap = infoMap
  },
  [types.SET_PREPAGE_INFO](state, {
    prePageInfo
  }) {
    state.prePageInfo = prePageInfo
  }
}

export default matutaions



// WEBPACK FOOTER //
// ./src/store/mutations.js